import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=47b536df&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=47b536df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b536df",
  null
  
)

export default component.exports